import { Card, Flex, Tabs, Typography } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import OngoingTrip from './OngoingTrip';
import VehicleInfo from './VehicleInfo';
import EmptyCard from '../../../components/EmptyCard/EmptyCard';

const { Text } = Typography;

const TripDetails = ({
  ongoingTripData,
  setOngoingTripData,
  onFullScreenToggle,
  vehicleDetails,
  selectedTripDetails,
}) => {
  return (
    <>
      {!selectedTripDetails?.trip_id ? (
        <EmptyCard
          description={
            <Flex vertical gap={20}>
              <Text strong>No trip selected</Text>
              <Text style={{ color: '#979EA4' }}>
                Please select a trip to view details
              </Text>
            </Flex>
          }
        />
      ) : (
        <Card
          className="full-height trip-details-card"
          variant="borderless"
          title={
            <Flex vertical style={{ padding: '11px 4px' }}>
              <Text
                style={{ fontSize: '0.875rem' }}
              >{`${selectedTripDetails?.vendor || 'Vendor name'}`}</Text>
              <Text>{`${selectedTripDetails?.trip_id || 'Trip ID'} | ${selectedTripDetails?.registration || 'Vehicle Number'}`}</Text>
            </Flex>
          }
          style={{
            overflowY: 'auto',
          }}
        >
          <Tabs
            type="card"
            size="large"
            className="full-height border-tabs"
            tabBarGutter="2rem"
            tabBarStyle={{
              backgroundColor: 'transparent',
              padding: 0,
            }}
            defaultActiveKey="1"
            // activeKey={activeKey}
            items={[
              {
                key: '1',
                label: 'Trip Info',
                children: (
                  <OngoingTrip
                    ongoingTripData={ongoingTripData}
                    setOngoingTripData={setOngoingTripData}
                    onFullScreenToggle={onFullScreenToggle}
                    selectedTripDetails={selectedTripDetails}
                  />
                ),
              },
              {
                key: '2',
                label: 'Vehicle Info',
                children: (
                  <VehicleInfo
                    vehicleDetails={vehicleDetails}
                    selectedTripDetails={selectedTripDetails}
                  />
                ),
              },
            ]}
            // onChange={activeKey => setActiveKey(activeKey)}
          />
        </Card>
      )}
    </>
  );
};

TripDetails.propTypes = {
  ongoingTripData: PropTypes.object,
  setOngoingTripData: PropTypes.func.isRequired,
  onFullScreenToggle: PropTypes.func.isRequired,
  vehicleDetails: PropTypes.object,
  selectedTripDetails: PropTypes.object,
};

export default React.memo(TripDetails);
